import React, { ReactNode } from "react";

import { TextButtonTypography, TextButtonWrapper } from "./styles";

export interface ITextButtonProps {
  label?: ReactNode;
  onClickHandler?: () => void;
  isDisabled?: boolean;
  textClass?: string;
  wrapperClass?: string;
  dataCy?: string;
}

const TextButton = ({
  label,
  onClickHandler,
  isDisabled,
  textClass,
  wrapperClass,
  dataCy,
}: ITextButtonProps) => {
  return (
    <TextButtonWrapper
      className={wrapperClass}
      $disabled={isDisabled}
      data-cy={dataCy}
      onClick={isDisabled ? undefined : onClickHandler}
    >
      <TextButtonTypography className={textClass}>{label}</TextButtonTypography>
    </TextButtonWrapper>
  );
};

export default TextButton;
